import { Grid } from '@mui/material';
import { memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import PmiTextField from 'shell/components/shared/text-field';
import ListGender from 'shell/components/shared/gender';
import { TimePicker } from '@mui/lab';

interface SupplementaryDataProps {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  configuration?: string;
  nothingRequired?: boolean;
}

const SupplementaryDataComponent = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
}: SupplementaryDataProps): React.ReactElement => {
  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Cognome redattore "
          aria-label="Cognome redattore"
          id="surnameEditor"
          name="surnameEditor"
          fullWidth
          disabled={disabled}
          helperText={errors?.surnameEditor}
          error={touched?.surnameEditor && Boolean(errors?.surnameEditor)}
          type="text"
          variant="outlined"
          value={values?.surnameEditor || ''}
          onChange={(event) => {
            onChange('surnameEditor', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Nome redattore "
          aria-label="Nome redattore"
          id="nameEditor"
          name="nameEditor"
          fullWidth
          disabled={disabled}
          helperText={errors?.nameEditor}
          error={touched?.nameEditor && Boolean(errors?.nameEditor)}
          type="text"
          variant="outlined"
          value={values?.nameEditor || ''}
          onChange={(event) => {
            onChange('nameEditor', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <ListGender
          value={values?.gender || ''}
          onChange={(event) => onChange('gender', event.target.value)}
          error={touched?.gender && Boolean(errors?.gender)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <TimePicker
          label="Ora formazione documento "
          aria-label="Ora formazione documento"
          value={values?.timeDocumentFormation || null}
          onChange={(date) => {
            onChange('timeDocumentFormation', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              id="timeDocumentFormation"
              {...params}
              fullWidth
              error={touched?.timeDocumentFormation && Boolean(errors?.timeDocumentFormation)}
              helperText={errors?.timeDocumentFormation}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};

SupplementaryDataComponent.displayName = 'Form Supplementary Data component';

const SupplementaryData = memo(SupplementaryDataComponent);

export default SupplementaryData;
